import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  OptionsModalComponent, type OptionsModalComponentProps,
} from './optionsModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    OptionsModal: OptionsModalComponentProps;
  }
}

modalRenderer.register('OptionsModal', OptionsModalComponent);
